import type { User } from './user';

export const getUserFullName = (
  user: Pick<User, 'firstName' | 'lastName' | 'email'>,
  backupName: string = user.email
): string => [user.firstName, user.lastName].filter(Boolean).join(' ') || backupName;
